import { Injectable, Injector } from '@angular/core';
import { CrudService, Filter, getPartialled } from '@mango/core';
import { Observable } from 'rxjs';
import { User } from './user';
import { SendActivationCodeResponse } from './send-activation-code-response';
import { map } from 'rxjs/operators';
import { SendMailing } from '../core/dto/sendMailing';
import { Relatie } from '../core/dto/relatie';

@Injectable()
export class UserService extends CrudService<User> {

    constructor(injector: Injector) { super(User, injector); }
    
    sendActivationCode(id: number) : Observable<SendActivationCodeResponse> {
        return this.http.post(`/api/connect/sendActivationCode?id=${id}`, {}) as Observable<SendActivationCodeResponse>;
    }

    sendForgotPassword(email: string) : Observable<SendActivationCodeResponse> {
        
        return this.http.post(`/api/connect/ForgotPassword?loginId=${email}`, {}) as Observable<SendActivationCodeResponse>;
    }

    resetPassword(user: User, currentUserPassword: string, newPassword: string): Observable<void> {
        return this.http.post<void>('/api/auth/connect/resetPassword', {
            currentUserPassword,
            newPassword,
            user: getPartialled(user, 'id')
        });
        
    }

    getCIJUserFilter(): Filter<User> {
        return new Filter<User>(fb => [fb.equal("hasRelaties",false)]);
    }

    startMailingUsers(users: User[], subject: string, message: string) {

        let query: string = `api/mail/startMailing`;
        var myUsers = [];

        users.forEach(user => {
            var u = new User()
            u.id = user.id;
            u.firstName = user.firstName;
            u.lastName = user.lastName;
            u.email = user.email;
            myUsers.push(u);
        })

        subject = (subject != null && subject != undefined ? subject : "");
        message = (message != null && message != undefined ? message : "")

        let sendMailing: SendMailing = {
            users: myUsers,
            subject: (subject != null && subject != undefined ? subject : ""),
            message: message.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/<p>/g, '').replace(/<\/p>/g, '<br>')
        };
                
        return this.http.post(query,sendMailing).pipe(map(x => x as SendMailingResponse));
    }

    
}


export class SendMailingResponse {
    successful: boolean;
}

